import React from 'react'
import clsx from 'clsx'

import { Input } from '../'

import './InputGroup.scss'

const InputGroup = ({
   className,
   id,
   label,
   value,
   onChange,
   right,
   isDarkTheme,
   ...props
}) => {
   return (
      <div className={clsx('InputGroup', className)}>
         <label className="InputGroup__label" htmlFor={id}>
            {label}
         </label>
         <div
            className={clsx(
               'InputGroup__wrapper',
               isDarkTheme && 'InputGroup__wrapper--dark'
            )}
         >
            <Input
               id={id}
               value={value}
               onChange={onChange}
               className={clsx(
                  'InputGroup__wrapper-input',
                  className && `${className}-input`,
                  isDarkTheme && 'InputGroup__wrapper-input--dark'
               )}
               {...props}
            />
            {right}
         </div>
      </div>
   )
}

export default InputGroup
